import React from 'react';
import Header from './Header';
import Footer from './Footer';
import VerticalSensorCard from './VerticalSensorCard';
import '../styles/SafetySensor.css';

import areaObstacleImg from '../assets/area_obstacle_avoidance_sensor_main.png';

const sensors = [
  {
    image: areaObstacleImg,
    title: 'Area Obstacle Avoidance Sensor',
    points: [
      'Adopting line synchronization mode with safe and reliable performance.',
      'Detecting fingers, hands and arms in different sizes.',
      'A wide range of dimensions, protection heights and detection methods are available.',
      'Can be customized according to various non-standard requirements of customers.',
    ],
    link: '/products/AreaObstacleAvoidanceSensor',
  },
];

const SafetySensor = () => {
  return (
    <div className="safety-sensor-page">
      <Header />
      <section className="safety-sensor-hero">
        <h1>Safety Sensors</h1>
        <p>
          Explore advanced safety sensors designed to protect people and machinery, ensuring compliance
          with industrial safety standards.
        </p>
      </section>

      <section className="sensor-card-grid">
        {sensors.map((sensor, index) => (
          <a href={sensor.link} className="sensor-card-link" key={index}>
            <VerticalSensorCard
              image={sensor.image}
              title={sensor.title}
              points={sensor.points}
            />
          </a>
        ))}
      </section>
      <Footer />
    </div>
  );
};

export default SafetySensor;
